var map = {
	"./01.svg": 1091,
	"./02.svg": 1092,
	"./03.svg": 1093,
	"./3in1.png": 1094,
	"./3yrreturns-icon.png": 1095,
	"./Exclamation-mark-red-icon.svg": 694,
	"./Fundscardsnew/Banner.png": 1096,
	"./Fundscardsnew/Banner2.png": 1097,
	"./Fundscardsnew/Large-cap-nfo-small-banner.png": 1098,
	"./Fundscardsnew/Motilal_Oswal_Nifty_Capital_Market_Index.png": 1099,
	"./Fundscardsnew/active-momentum-card-banner.png": 1100,
	"./Fundscardsnew/arrow_drop_down.png": 1101,
	"./Fundscardsnew/card-banner-budinesscycleNFO.png": 1102,
	"./Fundscardsnew/card-banner-manufacturingnfo.png": 1103,
	"./Fundscardsnew/card-consumption.png": 1104,
	"./Fundscardsnew/card-digital-india-nfo-banner.png": 1105,
	"./Fundscardsnew/card-finance.png": 1106,
	"./Fundscardsnew/card-healthcare.png": 1107,
	"./Fundscardsnew/card-it-telecom.png": 1108,
	"./Fundscardsnew/cardBanner.png": 1109,
	"./Fundscardsnew/dot_01.gif": 1110,
	"./Fundscardsnew/icGridview.jpg": 1111,
	"./Fundscardsnew/icListView.jpg": 1112,
	"./Fundscardsnew/ic_close.svg": 1113,
	"./Fundscardsnew/ic_dot.png": 1114,
	"./Fundscardsnew/icons8-pencil-14.png": 1115,
	"./Fundscardsnew/info-icon-blue.svg": 1116,
	"./Fundscardsnew/info-icon.jpg": 1117,
	"./Fundscardsnew/infrastructure-fund-card-banner.png": 1118,
	"./Fundscardsnew/innovation-opp-nfo-card-banner-new.png": 1119,
	"./Fundscardsnew/minimize-risk-card.png": 1120,
	"./Fundscardsnew/multiCapfundCardBanner.png": 1121,
	"./Fundscardsnew/nfo-card-banner-bse-1000-index-fund.webp": 1122,
	"./Fundscardsnew/nfo_card_banner_service_fund.svg": 1123,
	"./Fundscardsnew/nifty-momentum-card-banner.png": 1124,
	"./Fundscardsnew/pencil.png": 1125,
	"./Homepage/Account Statment.png": 1126,
	"./Homepage/App Store.png": 1127,
	"./Homepage/Blog-1.png": 1128,
	"./Homepage/Blog-2.png": 1129,
	"./Homepage/Blog-3.png": 1130,
	"./Homepage/Blog-4.png": 1131,
	"./Homepage/Blogs.png": 1132,
	"./Homepage/Business Portfolio.png": 1133,
	"./Homepage/Car-Big.png": 1134,
	"./Homepage/Car-inner.png": 1135,
	"./Homepage/Downloads.png": 1136,
	"./Homepage/Education-Big.png": 1137,
	"./Homepage/Education-inner.png": 1138,
	"./Homepage/Equity-man.png": 1139,
	"./Homepage/Facebook.png": 1140,
	"./Homepage/Footer Arrow.png": 1141,
	"./Homepage/Group Sites.png": 1142,
	"./Homepage/Holiday-Big.png": 1143,
	"./Homepage/Holiday-inner.png": 1144,
	"./Homepage/House-Big.png": 1145,
	"./Homepage/House-Inner.png": 1146,
	"./Homepage/Investment-Background.png": 1147,
	"./Homepage/Logo.png": 1148,
	"./Homepage/Main-blog.png": 1149,
	"./Homepage/Map.png": 1150,
	"./Homepage/Money Plant.png": 1151,
	"./Homepage/Motilal Building.svg": 1152,
	"./Homepage/Multiple-girl.png": 1153,
	"./Homepage/NAV.png": 1154,
	"./Homepage/Newsletter Logo.png": 1155,
	"./Homepage/Next-trillion.png": 1156,
	"./Homepage/PiggyBank.png": 1157,
	"./Homepage/Play man.png": 1158,
	"./Homepage/Playstore Logo.png": 1159,
	"./Homepage/Plus-Icon.png": 1160,
	"./Homepage/Rectangle 4132.png": 1161,
	"./Homepage/Rectangle 4293.png": 1162,
	"./Homepage/TAX.png": 1163,
	"./Homepage/Tools.png": 1164,
	"./Homepage/Top Arrow.png": 1165,
	"./Homepage/Top Button Arrow.png": 1166,
	"./Homepage/Twitter.png": 1167,
	"./Homepage/Value Strategy.png": 1168,
	"./Homepage/Wedding-Big.png": 1169,
	"./Homepage/Wedding-inner.png": 1170,
	"./Homepage/Whatsapp Logo.png": 1171,
	"./Homepage/Youtube.png": 1172,
	"./Homepage/adult-banking-blur-1.png": 1173,
	"./Homepage/apple.png": 1174,
	"./Homepage/building.png": 1175,
	"./Homepage/cancel.png": 1176,
	"./Homepage/cart.png": 1177,
	"./Homepage/common-application-icon.svg": 1178,
	"./Homepage/compare-icon.svg": 1179,
	"./Homepage/compare-portfolio-default 1.png": 1180,
	"./Homepage/compare-portfolio-default.png": 1181,
	"./Homepage/compare-portfolio.png": 1182,
	"./Homepage/compounding-magic-default.png": 1183,
	"./Homepage/compounding-magic.png": 1184,
	"./Homepage/documents-icons.zip": 1185,
	"./Homepage/factsheet-icon.svg": 1186,
	"./Homepage/fundcard-bg.svg": 1187,
	"./Homepage/fundsize-icon.svg": 1188,
	"./Homepage/goal-calculator-default.png": 1189,
	"./Homepage/goal-calculator.png": 1190,
	"./Homepage/info-icon.svg": 1191,
	"./Homepage/investor logo.png": 1192,
	"./Homepage/key-man.svg": 1193,
	"./Homepage/leaflte-icon.svg": 1194,
	"./Homepage/mail.png": 1195,
	"./Homepage/minamt-icon.svg": 1196,
	"./Homepage/piggyBG.svg": 1197,
	"./Homepage/playstore.png": 1198,
	"./Homepage/presentation-icon.svg": 1199,
	"./Homepage/return-icon.svg": 1200,
	"./Homepage/right-arrow.png": 1201,
	"./Homepage/risk-icon.svg": 1202,
	"./Homepage/risk-veryhigh.png": 1203,
	"./Homepage/search.png": 1204,
	"./Homepage/share-icon.png": 1205,
	"./Homepage/sip-calculator-default.png": 1206,
	"./Homepage/sip-calculator.png": 1207,
	"./Homepage/smartphone.png": 1208,
	"./Homepage/taxBG.svg": 1209,
	"./Homepage/undraw_super_woman_dv0y.png": 1210,
	"./Homepage/user.png": 1211,
	"./Homepage/whatsapp.png": 1212,
	"./Index-fund-logo-old.png": 1213,
	"./Index-fund-logo.png": 1214,
	"./LAS.svg": 1215,
	"./Logo copy.png": 1216,
	"./MOTOS.png": 1217,
	"./SP500-Cloud-396x400.gif": 1218,
	"./about-sheme.png": 1219,
	"./about/aboutBG.jpg": 1220,
	"./about/abtres.png": 1221,
	"./about/abtres.svg": 1222,
	"./about/building.jpg": 1223,
	"./about/download.png": 1224,
	"./about/download.svg": 1225,
	"./about/focusbtn.svg": 1226,
	"./about/headingImage.png": 1227,
	"./about/investment.png": 1228,
	"./about/investment2.png": 1229,
	"./about/overview1.png": 1230,
	"./about/people.svg": 1231,
	"./about/ra-profile.jpg": 1232,
	"./about/star.svg": 1233,
	"./about/trust.png": 1234,
	"./abt-1.png": 1235,
	"./abt-2.png": 1236,
	"./abt-3.png": 1237,
	"./abt-4.png": 1238,
	"./account/accountBG.svg": 1239,
	"./account/accountstatement.svg": 1240,
	"./account/captcha.svg": 1241,
	"./account/greenRight.svg": 1242,
	"./appitite-icon.jpg": 1243,
	"./arrowleft.png": 1244,
	"./ascons-banner.png": 1245,
	"./b-riskometer-mh.png": 1246,
	"./bank.png": 1247,
	"./banner-curve.png": 1248,
	"./banner-midcap150.jpg": 1249,
	"./banner-thumb.png": 1250,
	"./bg-bluelines.jpg": 1251,
	"./blue-line.png": 1252,
	"./calender.svg": 1253,
	"./call-icon.png": 1254,
	"./cards-arrow-l.png": 1255,
	"./cards-arrow-r.png": 1256,
	"./cards-waves.png": 1257,
	"./cart-icon.png": 1258,
	"./cart/Ellipse 2112.svg": 1259,
	"./cart/Filters.png": 1260,
	"./cart/Group 134.png": 1261,
	"./cart/Group 7244.png": 1262,
	"./cart/Group 7553.png": 1263,
	"./cart/Group 9056.png": 1264,
	"./cart/Homepage/Account Statment.png": 1265,
	"./cart/Homepage/App Store.png": 1266,
	"./cart/Homepage/Blog-1.png": 1267,
	"./cart/Homepage/Blog-2.png": 1268,
	"./cart/Homepage/Blog-3.png": 1269,
	"./cart/Homepage/Blog-4.png": 1270,
	"./cart/Homepage/Blogs.png": 1271,
	"./cart/Homepage/Business Portfolio.png": 1272,
	"./cart/Homepage/Car-Big.png": 1273,
	"./cart/Homepage/Car-inner.png": 1274,
	"./cart/Homepage/Downloads.png": 1275,
	"./cart/Homepage/Education-Big.png": 1276,
	"./cart/Homepage/Education-inner.png": 1277,
	"./cart/Homepage/Equity-man.png": 1278,
	"./cart/Homepage/Facebook.png": 1279,
	"./cart/Homepage/Footer Arrow.png": 1280,
	"./cart/Homepage/Group Sites.png": 1281,
	"./cart/Homepage/Holiday-Big.png": 1282,
	"./cart/Homepage/Holiday-inner.png": 1283,
	"./cart/Homepage/House-Big.png": 1284,
	"./cart/Homepage/House-Inner.png": 1285,
	"./cart/Homepage/Investment-Background.png": 1286,
	"./cart/Homepage/Logo.png": 1287,
	"./cart/Homepage/Main-blog.png": 1288,
	"./cart/Homepage/Map.png": 1289,
	"./cart/Homepage/Money Plant.png": 1290,
	"./cart/Homepage/Motilal Building.svg": 1291,
	"./cart/Homepage/Multiple-girl.png": 1292,
	"./cart/Homepage/NAV.png": 1293,
	"./cart/Homepage/Newsletter Logo.png": 1294,
	"./cart/Homepage/Next-trillion.png": 1295,
	"./cart/Homepage/PiggyBank.png": 1296,
	"./cart/Homepage/Play man.png": 1297,
	"./cart/Homepage/Playstore Logo.png": 1298,
	"./cart/Homepage/Plus-Icon.png": 1299,
	"./cart/Homepage/Rectangle 4132.png": 1300,
	"./cart/Homepage/Rectangle 4293.png": 1301,
	"./cart/Homepage/TAX.png": 1302,
	"./cart/Homepage/Tools.png": 1303,
	"./cart/Homepage/Top Arrow.png": 1304,
	"./cart/Homepage/Top Button Arrow.png": 1305,
	"./cart/Homepage/Twitter.png": 1306,
	"./cart/Homepage/Value Strategy.png": 1307,
	"./cart/Homepage/Wedding-Big.png": 1308,
	"./cart/Homepage/Wedding-inner.png": 1309,
	"./cart/Homepage/Whatsapp Logo.png": 1310,
	"./cart/Homepage/Youtube.png": 1311,
	"./cart/Homepage/adult-banking-blur-1.png": 1312,
	"./cart/Homepage/apple.png": 1313,
	"./cart/Homepage/building.png": 1314,
	"./cart/Homepage/cancel.png": 1315,
	"./cart/Homepage/cart.png": 1316,
	"./cart/Homepage/common-application-icon.svg": 1317,
	"./cart/Homepage/compare-icon.svg": 1318,
	"./cart/Homepage/compare-portfolio-default 1.png": 1319,
	"./cart/Homepage/compare-portfolio-default.png": 1320,
	"./cart/Homepage/compare-portfolio.png": 1321,
	"./cart/Homepage/compounding-magic-default.png": 1322,
	"./cart/Homepage/compounding-magic.png": 1323,
	"./cart/Homepage/factsheet-icon.svg": 1324,
	"./cart/Homepage/fundcard-bg.svg": 1325,
	"./cart/Homepage/fundsize-icon.svg": 1326,
	"./cart/Homepage/goal-calculator-default.png": 1327,
	"./cart/Homepage/goal-calculator.png": 1328,
	"./cart/Homepage/info-icon.svg": 1329,
	"./cart/Homepage/investor logo.png": 1330,
	"./cart/Homepage/key-man.svg": 1331,
	"./cart/Homepage/leaflte-icon.svg": 1332,
	"./cart/Homepage/mail.png": 1333,
	"./cart/Homepage/minamt-icon.svg": 1334,
	"./cart/Homepage/piggyBG.svg": 1335,
	"./cart/Homepage/playstore.png": 1336,
	"./cart/Homepage/presentation-icon.svg": 1337,
	"./cart/Homepage/return-icon.svg": 1338,
	"./cart/Homepage/right-arrow.png": 1339,
	"./cart/Homepage/risk-icon.svg": 1340,
	"./cart/Homepage/risk-veryhigh.png": 1341,
	"./cart/Homepage/search.png": 1342,
	"./cart/Homepage/share-icon.png": 1343,
	"./cart/Homepage/sip-calculator-default.png": 1344,
	"./cart/Homepage/sip-calculator.png": 1345,
	"./cart/Homepage/smartphone.png": 1346,
	"./cart/Homepage/taxBG.svg": 1347,
	"./cart/Homepage/undraw_super_woman_dv0y.png": 1348,
	"./cart/Homepage/user.png": 1349,
	"./cart/Homepage/whatsapp.png": 1350,
	"./cart/Money Flag.png": 1351,
	"./cart/Rectangle 3362.png": 1352,
	"./cart/Shake Hand.png": 1353,
	"./cart/accept.png": 1354,
	"./cart/addAcc.svg": 1355,
	"./cart/arrow_back.png": 1356,
	"./cart/arrowleft.png": 1357,
	"./cart/bob.png": 1358,
	"./cart/c1.png": 1359,
	"./cart/calendar_icon.svg": 1360,
	"./cart/card-sip-icon.svg": 1361,
	"./cart/card_lumpsum_icon.svg": 1362,
	"./cart/cart_dnf.svg": 1363,
	"./cart/close_icon.svg": 1364,
	"./cart/e1.svg": 1365,
	"./cart/e2.svg": 1366,
	"./cart/e3.svg": 1367,
	"./cart/e4.svg": 1368,
	"./cart/f1.png": 1369,
	"./cart/faq.svg": 1370,
	"./cart/female-icon.png": 1371,
	"./cart/fofBG.svg": 1372,
	"./cart/fofIcon.svg": 1373,
	"./cart/fund_icon.png": 1374,
	"./cart/greenRight.svg": 1375,
	"./cart/holding_icon.svg": 1376,
	"./cart/hourse.svg": 1377,
	"./cart/icons8-ok-64.svg": 1378,
	"./cart/info.png": 1379,
	"./cart/investment/Group 8534.jpg": 1380,
	"./cart/investment/Group 8534@2x.jpg": 1381,
	"./cart/investment/calender.svg": 1382,
	"./cart/investment/female.svg": 1383,
	"./cart/investment/leftBG.svg": 1384,
	"./cart/investment/leftbg.jpg": 1385,
	"./cart/investment/lumsum.svg": 1386,
	"./cart/investment/male.svg": 1387,
	"./cart/investment/red.svg": 1388,
	"./cart/investment/rightbg.svg": 1389,
	"./cart/investment/sip.svg": 1390,
	"./cart/investment/switch.svg": 1391,
	"./cart/investment/upload.svg": 1392,
	"./cart/key1.jpg": 1393,
	"./cart/key2.jpg": 1394,
	"./cart/key3.jpg": 1395,
	"./cart/keyimg.jpg": 1396,
	"./cart/lock.svg": 1397,
	"./cart/loginpeople.svg": 1398,
	"./cart/low_icon.png": 1399,
	"./cart/m1.png": 1400,
	"./cart/m2.png": 1401,
	"./cart/male-icon.png": 1402,
	"./cart/media.jpg": 1403,
	"./cart/mens.png": 1404,
	"./cart/mens.svg": 1405,
	"./cart/mfDetailbg.svg": 1406,
	"./cart/mftimeline.svg": 1407,
	"./cart/mgBG.svg": 1408,
	"./cart/minus_icon.svg": 1409,
	"./cart/noun_locked lock_1010538.svg": 1410,
	"./cart/overview1.png": 1411,
	"./cart/p1.png": 1412,
	"./cart/playicon.svg": 1413,
	"./cart/plus_icon.svg": 1414,
	"./cart/popup_side_img.svg": 1415,
	"./cart/postlogin/authentication-icon.svg": 1416,
	"./cart/postlogin/bank-icon.svg": 1417,
	"./cart/postlogin/bitcoin.svg": 1418,
	"./cart/postlogin/boost-btn-icon.png": 1419,
	"./cart/postlogin/broker-error-icon.svg": 1420,
	"./cart/postlogin/broker-icon.svg": 1421,
	"./cart/postlogin/broker-success-icon.svg": 1422,
	"./cart/postlogin/call-icon.svg": 1423,
	"./cart/postlogin/cancel (2).svg": 1424,
	"./cart/postlogin/card-add-to-cart-icon.svg": 1425,
	"./cart/postlogin/card-lumpsum-icon.svg": 1426,
	"./cart/postlogin/card-sip-icon.svg": 1427,
	"./cart/postlogin/cart-icon.svg": 1428,
	"./cart/postlogin/carttable-infoicon.svg": 1429,
	"./cart/postlogin/cashflow-checkout-icon.svg": 1430,
	"./cart/postlogin/cheque-icon.svg": 1431,
	"./cart/postlogin/delete-icon.svg": 1432,
	"./cart/postlogin/direct-ribbon.svg": 1433,
	"./cart/postlogin/edit-icon.svg": 1434,
	"./cart/postlogin/elss-fund.gif": 1435,
	"./cart/postlogin/email-icon.svg": 1436,
	"./cart/postlogin/error-table-icon.svg": 1437,
	"./cart/postlogin/exit-load-icon.svg": 1438,
	"./cart/postlogin/facebook-logo.svg": 1439,
	"./cart/postlogin/filter-icon.svg": 1440,
	"./cart/postlogin/folio-icon.svg": 1441,
	"./cart/postlogin/folio-joint.svg": 1442,
	"./cart/postlogin/folio-minor.svg": 1443,
	"./cart/postlogin/folio-single.svg": 1444,
	"./cart/postlogin/footer-blue-bg.svg": 1445,
	"./cart/postlogin/footer-chatwithus-icon.svg": 1446,
	"./cart/postlogin/footer-faqs-icon.svg": 1447,
	"./cart/postlogin/footer-searchlocation-icon.svg": 1448,
	"./cart/postlogin/footer-whatsapp-icon.svg": 1449,
	"./cart/postlogin/greenarrow-icon.svg": 1450,
	"./cart/postlogin/greentick-icon.svg": 1451,
	"./cart/postlogin/grid-icon.svg": 1452,
	"./cart/postlogin/index-funds.gif": 1453,
	"./cart/postlogin/info-icon.svg": 1454,
	"./cart/postlogin/infobig-icon.svg": 1455,
	"./cart/postlogin/instagram-logo.svg": 1456,
	"./cart/postlogin/internationalBG.jpg": 1457,
	"./cart/postlogin/list-icon.svg": 1458,
	"./cart/postlogin/loader-logo.svg": 1459,
	"./cart/postlogin/main-clip.svg": 1460,
	"./cart/postlogin/mandate-homepage-banner.jpg": 1461,
	"./cart/postlogin/mandate-icon.svg": 1462,
	"./cart/postlogin/mastercard-icon.svg": 1463,
	"./cart/postlogin/money-bag.svg": 1464,
	"./cart/postlogin/more-vertical.svg": 1465,
	"./cart/postlogin/multiasset-balancing-mob-banner.jpg": 1466,
	"./cart/postlogin/neft-rtgs-icon.svg": 1467,
	"./cart/postlogin/neftrtgs-icon.svg": 1468,
	"./cart/postlogin/net-banking-icon.svg": 1469,
	"./cart/postlogin/netbanking-otm-icon.svg": 1470,
	"./cart/postlogin/order-icon.svg": 1471,
	"./cart/postlogin/otm-mandate-mob.jpg": 1472,
	"./cart/postlogin/payment-fail.svg": 1473,
	"./cart/postlogin/payment-method-icon.svg": 1474,
	"./cart/postlogin/payment-success.svg": 1475,
	"./cart/postlogin/payment-summary-icon.svg": 1476,
	"./cart/postlogin/payment-waiting.svg": 1477,
	"./cart/postlogin/pms-homepage-mob-banner.jpg": 1478,
	"./cart/postlogin/profit.svg": 1479,
	"./cart/postlogin/redamount-icon.svg": 1480,
	"./cart/postlogin/redarrow-icon.svg": 1481,
	"./cart/postlogin/redemption-icon.svg": 1482,
	"./cart/postlogin/regular-ribbon.svg": 1483,
	"./cart/postlogin/review-checkout-icon.svg": 1484,
	"./cart/postlogin/rupee-sign.svg": 1485,
	"./cart/postlogin/schedule-sip-icon.svg": 1486,
	"./cart/postlogin/search-icon.svg": 1487,
	"./cart/postlogin/sip-error-icon.svg": 1488,
	"./cart/postlogin/sip-shubh-aarambh-mob-banner.jpg": 1489,
	"./cart/postlogin/sipmenu-bank.svg": 1490,
	"./cart/postlogin/sipmenu-cancel.svg": 1491,
	"./cart/postlogin/sipmenu-feedback.svg": 1492,
	"./cart/postlogin/sipmenu-pause.svg": 1493,
	"./cart/postlogin/sipmenu-statement.svg": 1494,
	"./cart/postlogin/small-clip.svg": 1495,
	"./cart/postlogin/stp-icon.svg": 1496,
	"./cart/postlogin/swp-icon.svg": 1497,
	"./cart/postlogin/tax-icon.svg": 1498,
	"./cart/postlogin/thank-you.png": 1499,
	"./cart/postlogin/twitter-logo.svg": 1500,
	"./cart/postlogin/upi-icon.svg": 1501,
	"./cart/postlogin/whatsapp-banner.jpg": 1502,
	"./cart/postlogin/x-circle.svg": 1503,
	"./cart/postlogin/youtube-logo.svg": 1504,
	"./cart/rightCheck.svg": 1505,
	"./cart/rightarrow.svg": 1506,
	"./cart/rupeesBg.svg": 1507,
	"./cart/rupeesIcon.svg": 1508,
	"./cart/sbi.png": 1509,
	"./cart/searchbar.svg": 1510,
	"./cart/sip_info_icon.svg": 1511,
	"./cart/tagmsg.svg": 1512,
	"./cart/taxBG.svg": 1513,
	"./cart/taxIcon.svg": 1514,
	"./cart/transgender-icon.png": 1515,
	"./cart/v1.svg": 1516,
	"./cart/v2.svg": 1517,
	"./cart/v3.svg": 1518,
	"./cart/v4.svg": 1519,
	"./cart/v5.svg": 1520,
	"./cart/v6.svg": 1521,
	"./cart/v7.svg": 1522,
	"./cart/yellowcolor.png": 1523,
	"./cart/yellowcolor2x.png": 1524,
	"./cashflow/background1.png": 1525,
	"./cashflow/background1.svg": 1526,
	"./cashflow/background2.png": 1527,
	"./cashflow/background2.svg": 1528,
	"./cashflow/background3.png": 1529,
	"./cashflow/background3.svg": 1530,
	"./cashflow/background4.png": 1531,
	"./cashflow/background4.svg": 1532,
	"./cashflow/banner_chart.svg": 1533,
	"./cashflow/bannerbg.png": 1534,
	"./cashflow/bannerbg.svg": 1535,
	"./cashflow/cashflow_icon1.svg": 1536,
	"./cashflow/cashflow_icon2.svg": 1537,
	"./cashflow/cashflow_icon3.svg": 1538,
	"./cashflow/cashflow_icon4.svg": 1539,
	"./cashflow/cashflowplan_graphic.svg": 1540,
	"./cashflow/introcashplan.svg": 1541,
	"./category/BannerMultiCapNfo.png": 1542,
	"./category/CFFundBanner.jpg": 1543,
	"./category/CFFundBannerMobile.png": 1544,
	"./category/CFFundCardBanner.png": 1545,
	"./category/Consumption-fund-card-banner.png": 1546,
	"./category/HT-AS.svg": 1547,
	"./category/HT-minor.svg": 1548,
	"./category/HT-single.svg": 1549,
	"./category/MOFSL-Post-Log-In-1076X170.jpg": 1550,
	"./category/MOFSL-Post-Log-In-370X120.jpg": 1551,
	"./category/MOFSL-Post-Log-In-financial-services-370X120.jpg": 1552,
	"./category/NFO_PostLogin_Consumption_Fund_Hero_Mobile.png": 1553,
	"./category/NFO_PostLogin_Consumption_Fund_Hero_desktop.png": 1554,
	"./category/NFO_PostLogin_Diversified_Fund_Hero_Mobile.jpg": 1555,
	"./category/NFO_PostLogin_Diversified_Fund_Hero_desktop.jpg": 1556,
	"./category/NFO_PostLogin_MidSmall_Finacial_Services_Hero_desktop.jpg": 1557,
	"./category/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_Mobile.jpg": 1558,
	"./category/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_desktop.jpg": 1559,
	"./category/Postlogin-switch-card-banner.png": 1560,
	"./category/active-momentum-checkout-banner-mob.png": 1561,
	"./category/active-momentum-checkout-banner-web.png": 1562,
	"./category/addedcart-icon.svg": 1563,
	"./category/addtocart-icon.svg": 1564,
	"./category/banner-consumption-comp.jpg": 1565,
	"./category/banner-consumption-mobile-comp.jpg": 1566,
	"./category/banner-finance-comp.jpg": 1567,
	"./category/banner-finance-mobile-comp.jpg": 1568,
	"./category/banner-healthcare-comp.jpg": 1569,
	"./category/banner-healthcare-mobile-comp.jpg": 1570,
	"./category/banner-it-telecom-comp.jpg": 1571,
	"./category/banner-it-telecom-mobile-comp.jpg": 1572,
	"./category/banner.PNG": 1573,
	"./category/bse-1000-index-fund-connector-desktop.webp": 1574,
	"./category/bse-1000-index-fund-connector-mobile.webp": 1575,
	"./category/businesscycle-nfo-banner.png": 1576,
	"./category/calendar_icon.svg": 1577,
	"./category/card-banner-budinesscycle_NFO.png": 1578,
	"./category/card-lumpsum-icon.svg": 1579,
	"./category/card-sip-icon.svg": 1580,
	"./category/curved-arrow-right.svg": 1581,
	"./category/curved-arrow.svg": 1582,
	"./category/defence-nfo-quickbuy-banner.png": 1583,
	"./category/digital-india-nfo-banner.png": 1584,
	"./category/finanical-services-fundcard.png": 1585,
	"./category/fund-Card-banner-diversified.png": 1586,
	"./category/fund-card-banner-so-fund.png": 1587,
	"./category/fund-size-icon.svg": 1588,
	"./category/fundcard-bg.svg": 1589,
	"./category/fundsize-icon.svg": 1590,
	"./category/grid-icon.svg": 1591,
	"./category/info-icon copy.svg": 1592,
	"./category/info-icon-outline.svg": 1593,
	"./category/info-icon.svg": 1594,
	"./category/infrastructure-fund-checkout-banner-desktop.jpg": 1595,
	"./category/infrastructure-fund-checkout-banner-mobile.jpg": 1596,
	"./category/innovation-switch-mob-rebrand.jpg": 1597,
	"./category/innovation-switch-web-rebrand.jpg": 1598,
	"./category/list-icon.svg": 1599,
	"./category/manufacturing-nfo-banner.png": 1600,
	"./category/mi-filter.svg": 1601,
	"./category/min-amount.svg": 1602,
	"./category/minamt-icon.svg": 1603,
	"./category/multi-factor-card-banner.png": 1604,
	"./category/nfo-banner-consumption-comp-mobile.jpg": 1605,
	"./category/nfo-banner-consumption-comp.jpg": 1606,
	"./category/nfo-banner-finance-comp-mobile.jpg": 1607,
	"./category/nfo-banner-finance-comp.jpg": 1608,
	"./category/nfo-banner-healthcare-comp-mobile.jpg": 1609,
	"./category/nfo-banner-healthcare-comp.jpg": 1610,
	"./category/nfo-banner-it-telecom-comp-mobile.jpg": 1611,
	"./category/nfo-banner-it-telecom-comp.jpg": 1612,
	"./category/nfo-card-banner-special-opportunities-fund.webp": 1613,
	"./category/nfo_checkout_cart_banner_mobile_service_fund.svg": 1614,
	"./category/nfo_checkout_cart_banner_service_fund.svg": 1615,
	"./category/nfo_postlogin_arbitage_banner_desk.jpg": 1616,
	"./category/nfo_postlogin_arbitage_banner_mob.png": 1617,
	"./category/nifty-500-momentum-banner.png": 1618,
	"./category/nifty-momentum-Banner.png": 1619,
	"./category/nifty500Momentum.png": 1620,
	"./category/no-mandate-icon.svg": 1621,
	"./category/postlogin-switch-card-banner-mobile.png": 1622,
	"./category/qb_cancel_icon.svg": 1623,
	"./category/qb_mod_icon.svg": 1624,
	"./category/qb_remove_item.svg": 1625,
	"./category/return-icon.svg": 1626,
	"./category/risk-icon.svg": 1627,
	"./category/risk-veryhigh.png": 1628,
	"./category/riskometer-icon.svg": 1629,
	"./category/search-icon.svg": 1630,
	"./category/shopping-bag.svg": 1631,
	"./category/slide1.png": 1632,
	"./category/sortBy.svg": 1633,
	"./category/special-opportunities-fund-desktop.webp": 1634,
	"./category/special-opportunities-fund-mobile.webp": 1635,
	"./chart1.svg": 1636,
	"./check-list-icon.svg": 1637,
	"./check-list.png": 1638,
	"./check-list.svg": 1639,
	"./check-shadow.svg": 1640,
	"./check.svg": 1641,
	"./cheque-bg.webp": 1642,
	"./close.png": 695,
	"./cloud-upload-error.webp": 1643,
	"./cloud-upload.webp": 1644,
	"./common-inner-nfo-banner-mob.png": 1645,
	"./common-inner-nfo-banner.png": 1646,
	"./comparison-icon.png": 1647,
	"./contact/Map.png": 1648,
	"./contact/building.svg": 1649,
	"./contact/building_icon.png": 1650,
	"./contact/mail.png": 1651,
	"./contact/smartphone.png": 1652,
	"./contact/user.png": 1653,
	"./contactus-banner.jpg": 1654,
	"./crisis-icon.png": 1655,
	"./dash/404_error.svg": 1656,
	"./dash/accountstmt.svg": 1657,
	"./dash/annualreturn.png": 1658,
	"./dash/banner.svg": 1659,
	"./dash/bar.svg": 1660,
	"./dash/basket-buy-banner.gif": 1661,
	"./dash/buymore.svg": 1662,
	"./dash/calVec.svg": 1663,
	"./dash/coin-light.svg": 1664,
	"./dash/coin.svg": 1665,
	"./dash/currentvalue.png": 1666,
	"./dash/dailygain.png": 1667,
	"./dash/dash.svg": 1668,
	"./dash/green.svg": 1669,
	"./dash/investment.png": 1670,
	"./dash/latestActive.svg": 1671,
	"./dash/minus.svg": 1672,
	"./dash/nfo-popup/Mob-responsive-720x540-px_gold-and-silver-NFO.jpeg": 1673,
	"./dash/nfo-popup/conclave-event.jpeg": 1674,
	"./dash/nfo-popup/enhanced-popup-banner.jpeg": 1675,
	"./dash/nfo-popup/quality-popup-banner.jpeg": 1676,
	"./dash/orderbook.svg": 1677,
	"./dash/plus.svg": 1678,
	"./dash/portfolio-dnf-icon.svg": 1679,
	"./dash/portfolioview.png": 1680,
	"./dash/red.svg": 1681,
	"./dash/redem.svg": 1682,
	"./dash/scheduletrans.svg": 1683,
	"./dash/sipUp.svg": 1684,
	"./dash/totalInvestment.png": 1685,
	"./dash/totalgain.png": 1686,
	"./dash/transhis.svg": 1687,
	"./dash/upcomming.svg": 1688,
	"./dash/zbp_folio_creation_icon.svg": 1689,
	"./dash/zbp_make_payment_icon.svg": 1690,
	"./dash/zbp_select_fund_icon.svg": 1691,
	"./dash/zero_balance_portfolio.svg": 1692,
	"./dash/zero_balance_steps_icon.svg": 1693,
	"./diversified-icon.jpg": 1694,
	"./dollarhedge-graph.png": 1695,
	"./downlo-tab-icons.png": 1696,
	"./download-icons-01.png": 1697,
	"./download-icons-02.png": 1698,
	"./download-icons-03.png": 1699,
	"./download-icons-04.png": 1700,
	"./download-icons-05.png": 1701,
	"./download-icons-06 - Copy.png": 1702,
	"./download-icons-06.png": 1703,
	"./download/Edit.svg": 1704,
	"./download/banner.svg": 1705,
	"./download/close.svg": 1706,
	"./download/cloud.svg": 1707,
	"./download/email.svg": 1708,
	"./download/pdf.png": 1709,
	"./download/view.svg": 1710,
	"./download/whatsapp.svg": 1711,
	"./download/xls.png": 1712,
	"./downloadnav-icon.png": 1713,
	"./dtl-man.png": 1714,
	"./dynamic-fund-coffee-desbanner.jpg": 1715,
	"./dynamic-fund-coffee-mobbanner.jpg": 1716,
	"./e-mandate-success-icon.png": 689,
	"./email-icon.png": 1717,
	"./emandate-inprocess.svg": 701,
	"./equity-banner-inner-mob.jpg": 1718,
	"./equity-banner-inner.jpg": 1719,
	"./equity-banner-mob.jpg": 1720,
	"./equity-banner.jpg": 1721,
	"./exclaimation_yellow.png": 1722,
	"./existinguser.svg": 1723,
	"./eye.svg": 1724,
	"./f25-banner-mob.jpg": 1725,
	"./f25-banner.jpg": 1726,
	"./f25-starbull.png": 1727,
	"./f500-valuation-graph1.jpg": 1728,
	"./fab-background.png": 1729,
	"./fab-logo.png": 1730,
	"./fabPlan/calImagePopUp.png": 1731,
	"./fabPlan/calImagePopUp2X.png": 1732,
	"./fabPlan/fab-background.png": 1733,
	"./fabPlan/fab-background_11zon.png": 1734,
	"./fabPlan/fab-logo.png": 1735,
	"./fabPlan/fab-logo@2x.png": 1736,
	"./fabPlan/gold.png": 1737,
	"./fabPlan/idea_fab_plan.png": 1738,
	"./fabPlan/info-icon.svg": 1739,
	"./fabPlan/info-icon2.svg": 1740,
	"./fabPlan/info-icon3.svg": 1741,
	"./fabPlan/loading.svg": 1742,
	"./fabPlan/order-summary-icon.svg": 1743,
	"./fabPlan/pause-process.png": 1744,
	"./fabPlan/pencil-blue.svg": 1745,
	"./fabPlan/pencil.svg": 1746,
	"./fabPlan/recommended-icon.png": 1747,
	"./fabPlan/ribbon-strip.png": 1748,
	"./fabPlan/small-calendar-2.svg": 1749,
	"./fabPlan/small-calendar.svg": 1750,
	"./fabPlan/statistics.png": 1751,
	"./fabPlan/tablet-active.png": 1752,
	"./fabPlan/thankyou-page-banner.svg": 1753,
	"./fabPlan/thumbs-up.png": 1754,
	"./failed-mandate-icon.png": 690,
	"./faq-banner-thumb.png": 1755,
	"./faq-etf.png": 1756,
	"./faq-icon.png": 1757,
	"./faq-icon.svg": 1758,
	"./faq-man-woman.png": 1759,
	"./faq.jpg": 1760,
	"./faq/faq.svg": 1761,
	"./faq/searchbar.svg": 1762,
	"./favicon-index.png": 1763,
	"./favicon.png": 1764,
	"./fbank-indices.jpg": 1765,
	"./fbank-valuation-graph1.jpg": 1766,
	"./features-points-01-th.jpg": 1767,
	"./features-points-01.jpg": 1768,
	"./features-points-02-th.png": 1769,
	"./features-points-02.png": 1770,
	"./features-points-03.png": 1771,
	"./feedback-img.png": 1772,
	"./flower-etf.png": 1773,
	"./footer-blue-bg.bad4f86f.svg": 1774,
	"./footer/appstore.png": 1775,
	"./footer/appstore_mobile.png": 1776,
	"./footer/arrow_down_thin.png": 1777,
	"./footer/arrow_up_filled.png": 1778,
	"./footer/background.png": 1779,
	"./footer/call.png": 1780,
	"./footer/facebook.png": 1781,
	"./footer/instagram.png": 1782,
	"./footer/linkedin.png": 1783,
	"./footer/mail.png": 1784,
	"./footer/mo_mf_logo.svg": 1785,
	"./footer/playstore.png": 1786,
	"./footer/playstore_mobile.png": 1787,
	"./footer/whatsapp.png": 1788,
	"./footer/x.png": 1789,
	"./footer/youtube.png": 1790,
	"./fund150-banner.jpg": 1791,
	"./fundIcon/MHR.svg": 1792,
	"./fundIcon/fofBG.svg": 1793,
	"./fundIcon/fofIcon.svg": 1794,
	"./fundIcon/growth_icon.svg": 1795,
	"./fundIcon/growth_icon1.svg": 1796,
	"./fundIcon/growth_icon3.svg": 1797,
	"./fundIcon/pencil.svg": 1798,
	"./fundIcon/rupeesBg.svg": 1799,
	"./fundIcon/rupeesIcon.svg": 1800,
	"./fundIcon/taxBG.svg": 1801,
	"./fundIcon/taxIcon.svg": 1802,
	"./globalexposure-graph.png": 1803,
	"./greenRight.svg": 1804,
	"./half-circle.png": 1805,
	"./header/appstore_mobile_black.png": 1806,
	"./header/arrow_down_thin.svg": 1807,
	"./header/arrow_right.png": 1808,
	"./header/become-distributor_new.svg": 1809,
	"./header/close.png": 1810,
	"./header/commodity.svg": 1811,
	"./header/debt_and_liquid.svg": 1812,
	"./header/downloads_new.svg": 1813,
	"./header/dropdown-arrow.svg": 1814,
	"./header/etf.svg": 1815,
	"./header/faq_new.svg": 1816,
	"./header/fund_icon.png": 1817,
	"./header/hybrid_and_balanced.svg": 1818,
	"./header/index_fund.svg": 1819,
	"./header/indian_equity.svg": 1820,
	"./header/international_equity.svg": 1821,
	"./header/login_new.svg": 1822,
	"./header/mobile_menu.png": 1823,
	"./header/multi_asset.svg": 1824,
	"./header/nfo_beacon.gif": 1825,
	"./header/phone.png": 1826,
	"./header/phone_red.png": 1827,
	"./header/playstore_mobile_black.png": 1828,
	"./header/quick_purchase_new.svg": 1829,
	"./header/why_choose_us_new.svg": 1830,
	"./higherdividend-graph.png": 1831,
	"./historic-performace-gsec-fof.png": 1832,
	"./historic-performace.png": 1833,
	"./home-indexfunds.png": 1834,
	"./home/Blog-1.png": 1835,
	"./home/Blog-2.png": 1836,
	"./home/Blog-3.png": 1837,
	"./home/Blog-4.png": 1838,
	"./home/Equity-man.png": 1839,
	"./home/Investment-Background.png": 1840,
	"./home/Main-blog.png": 1841,
	"./home/Multiple-girl.png": 1842,
	"./home/Playman.png": 1843,
	"./home/account_statement.png": 1844,
	"./home/apple.png": 1845,
	"./home/banner1.svg": 1846,
	"./home/blog.png": 1847,
	"./home/cashflow-home.png": 1848,
	"./home/circle-bg.png": 1849,
	"./home/download.png": 1850,
	"./home/elss-shark-banner-desktop.jpg": 1851,
	"./home/elss-shark-banner-mob.jpg": 1852,
	"./home/f25-focus-banner-desktop.jpg": 1853,
	"./home/f25-product-focus-banner-mob.jpg": 1854,
	"./home/headingImage-red.png": 1855,
	"./home/investment-philosophy.jpg": 1856,
	"./home/investorlogo.png": 1857,
	"./home/key-man.svg": 1858,
	"./home/mandate-icon.png": 1859,
	"./home/mfwhatsapp.png": 1860,
	"./home/minimalinv-banner-desktop.jpg": 1861,
	"./home/minimalinv-banner-mob.jpg": 1862,
	"./home/moviindex-home.png": 1863,
	"./home/multi-and-dynamic-cake-banner-desktop.jpg": 1864,
	"./home/multi-and-dynamic-cake-banner-mob.jpg": 1865,
	"./home/nav.png": 1866,
	"./home/playstore.png": 1867,
	"./home/ques.png": 1868,
	"./home/quick-invest.png": 1869,
	"./home/shortblast-home.png": 1870,
	"./home/sipbooster-home.png": 1871,
	"./home/small-is-powerful-banner-desktop.jpg": 1872,
	"./home/small-is-powerful-earth-banner-mob.jpg": 1873,
	"./home/smartmockups_jzwdpybx.png": 1874,
	"./home/tools.png": 1875,
	"./home/wand.png": 706,
	"./home/whatsapp.png": 1876,
	"./how-asset-allocation.png": 1877,
	"./icon-1.png": 129,
	"./icon-2.png": 220,
	"./icon-3.png": 130,
	"./icon-unclaimred.png": 1878,
	"./index-fund-banners-2-xs.png": 1879,
	"./index-fund-banners-2.png": 1880,
	"./index-fund-banners-3-xs.png": 1881,
	"./index-fund-banners-3.png": 1882,
	"./index-fund-banners-4-xs.png": 1883,
	"./index-fund-banners-4.png": 1884,
	"./index-fund-banners-xs.png": 1885,
	"./index-fund-banners.png": 1886,
	"./index-fund-icons-d-cl.png": 1887,
	"./index-fund-icons-growth-cl.png": 1888,
	"./index-fund-icons-low-cl.png": 1889,
	"./index-fund-icons-risk-cl.png": 1890,
	"./index-fund-icons-trans-cl.png": 1891,
	"./index-icon1.png": 1892,
	"./index-icon11.png": 1893,
	"./index-icon2.png": 1894,
	"./index-icon22.png": 1895,
	"./index-icon3.png": 1896,
	"./index-icon33.png": 1897,
	"./index-icon4.png": 1898,
	"./index-icon44.png": 1899,
	"./index-icon5.png": 1900,
	"./index-icon55.png": 1901,
	"./indexlist-arrow-inner.png": 1902,
	"./indexlist-arrow.png": 1903,
	"./indian-market-cloud.png": 1904,
	"./info-gray.svg": 739,
	"./info.png": 1905,
	"./info.svg": 1906,
	"./inndex-fund-small-midcap-mob.jpg": 1907,
	"./inndex-fund-small-midcap.jpg": 1908,
	"./instant-sip-icon.png": 1909,
	"./international/internationalBG.jpg": 1910,
	"./international/key1.png": 1911,
	"./international/key2.png": 1912,
	"./international/key3.png": 1913,
	"./international/mens.jpg": 1914,
	"./international/tag.png": 1915,
	"./intersetialBigImg.svg": 1916,
	"./investment/Cross-icon.svg": 1917,
	"./investment/Group 8534.jpg": 1918,
	"./investment/Group 8534@2x.jpg": 1919,
	"./investment/boost-btn-icon.png": 1920,
	"./investment/calender.svg": 1921,
	"./investment/female.svg": 1922,
	"./investment/filter-icon.svg": 1923,
	"./investment/leftBG.svg": 1924,
	"./investment/leftbg.jpg": 1925,
	"./investment/lumsum.svg": 1926,
	"./investment/male.svg": 1927,
	"./investment/order-icon.svg": 1928,
	"./investment/red.svg": 1929,
	"./investment/rightbg.svg": 1930,
	"./investment/schedule-sip-icon.svg": 1931,
	"./investment/sip-boosted.png": 1932,
	"./investment/sip.svg": 1933,
	"./investment/sipmenu-bank.svg": 1934,
	"./investment/sipmenu-cancel.svg": 1935,
	"./investment/sipmenu-feedback.svg": 1936,
	"./investment/sipmenu-pause.svg": 1937,
	"./investment/sipmenu-statement.svg": 1938,
	"./investment/small-clip.svg": 1939,
	"./investment/switch.svg": 1940,
	"./investment/upload.svg": 1941,
	"./investment/x-circle.svg": 1942,
	"./invobj-tab-icon-w.png": 1943,
	"./invobj-tab-icon.png": 1944,
	"./isip.svg": 1945,
	"./kimform-icon.svg": 1946,
	"./kyc/thank-you.png": 1947,
	"./landing/MHR.svg": 1948,
	"./landing/PMS-BG.svg": 1949,
	"./landing/diverse-portfolio-w.png": 1950,
	"./landing/fofBG.svg": 1951,
	"./landing/fofIcon.svg": 1952,
	"./landing/growth_icon.svg": 1953,
	"./landing/growth_icon1.svg": 1954,
	"./landing/growth_icon3.svg": 1955,
	"./landing/hourse.svg": 1956,
	"./landing/key1.jpg": 1957,
	"./landing/key2.jpg": 1958,
	"./landing/key3.jpg": 1959,
	"./landing/keyimg.jpg": 1960,
	"./landing/m1.png": 1961,
	"./landing/m2.png": 1962,
	"./landing/m3.png": 1963,
	"./landing/m4.png": 1964,
	"./landing/m5.png": 1965,
	"./landing/mgBG.svg": 1966,
	"./landing/p1.png": 1967,
	"./landing/p2.png": 1968,
	"./landing/p3.png": 1969,
	"./landing/p4.png": 1970,
	"./landing/p5.png": 1971,
	"./landing/passBGbottom.svg": 1972,
	"./landing/playicon.svg": 1973,
	"./landing/pms1.png": 1974,
	"./landing/pms2.png": 1975,
	"./landing/pms3.png": 1976,
	"./landing/pms4.png": 1977,
	"./landing/professional-management-w.png": 1978,
	"./landing/rightarrow.svg": 1979,
	"./landing/rupeesBg.svg": 1980,
	"./landing/rupeesIcon.svg": 1981,
	"./landing/safe-transperent-w.png": 1982,
	"./landing/tax-saving-w.png": 1983,
	"./landing/taxBG.svg": 1984,
	"./landing/taxIcon.svg": 1985,
	"./large-grows.png": 1986,
	"./leaflate-icon.svg": 1987,
	"./leftBG.svg": 1988,
	"./leftbg.jpg": 1989,
	"./level2-seperator.png": 1990,
	"./level5-seperator.png": 1991,
	"./line.png": 1992,
	"./list-arrow-inner.png": 1993,
	"./list-arrow.png": 1994,
	"./listing/Mask Group 31.svg": 1995,
	"./listing/P_M_R.svg": 1996,
	"./listing/Rectangle 4184.svg": 1997,
	"./listing/bg_pms.svg": 1998,
	"./listing/charttest.svg": 1999,
	"./listing/d.png": 2000,
	"./listing/db_small.png": 2001,
	"./listing/e1.svg": 2002,
	"./listing/e2.svg": 2003,
	"./listing/e3.svg": 2004,
	"./listing/e4.svg": 2005,
	"./listing/investmentp.svg": 2006,
	"./listing/l1.png": 2007,
	"./listing/lt.png": 2008,
	"./listing/mens.png": 2009,
	"./listing/mens.svg": 2010,
	"./listing/mfDetailbg.svg": 2011,
	"./listing/p1.png": 2012,
	"./listing/p2.png": 2013,
	"./listing/p_icon1.svg": 2014,
	"./listing/pms-startegy-banner.png": 2015,
	"./listing/pmsBG.svg": 2016,
	"./listing/pms_v1.png": 2017,
	"./listing/pms_v10.png": 2018,
	"./listing/pms_v2.png": 2019,
	"./listing/pms_v3.png": 2020,
	"./listing/pms_v4.png": 2021,
	"./listing/pms_v5.png": 2022,
	"./listing/pms_v6.png": 2023,
	"./listing/pms_v7.png": 2024,
	"./listing/pms_v8.png": 2025,
	"./listing/pms_v9.png": 2026,
	"./listing/pmsbottom.svg": 2027,
	"./listing/po.png": 2028,
	"./listing/portolifo_left.svg": 2029,
	"./listing/portolifo_right.svg": 2030,
	"./listing/r1.png": 2031,
	"./listing/r_small.png": 2032,
	"./listing/red_pdf.svg": 2033,
	"./listing/tr.png": 2034,
	"./listing/v1.svg": 2035,
	"./listing/v10.svg": 2036,
	"./listing/v11.svg": 2037,
	"./listing/v12.svg": 2038,
	"./listing/v13.svg": 2039,
	"./listing/v14.svg": 2040,
	"./listing/v2.svg": 2041,
	"./listing/v3.svg": 2042,
	"./listing/v4.svg": 2043,
	"./listing/v5.svg": 2044,
	"./listing/v6.svg": 2045,
	"./listing/v7.svg": 2046,
	"./listing/v9.svg": 2047,
	"./listing/why1.png": 2048,
	"./listing/why2.png": 2049,
	"./listing/why3.png": 2050,
	"./listing/why4.png": 2051,
	"./lock.svg": 2052,
	"./lockpwd.png": 2053,
	"./login-etf-banner.svg": 2054,
	"./login-image.png": 740,
	"./login/300x250-01.gif": 2055,
	"./login/CFFundPasscodeImage.gif": 2056,
	"./login/Factor-momentum-Money-control_New.gif": 2057,
	"./login/Flexicap-Fund-Banner.gif": 2058,
	"./login/Info-icon-yellow.svg": 2059,
	"./login/Large-Cap-Fund-passcode-banner.jpg": 2060,
	"./login/Web-passcode-SO.jpg": 2061,
	"./login/Web-popup-Banner.jpg": 2062,
	"./login/Website-Blogs-Banner-closing-340X340.jpg": 2063,
	"./login/Website-Passcode-Banner-new.jpg": 2064,
	"./login/Website-Passcode-Banner.jpg": 2065,
	"./login/Website-passcode-Banner-new-340X340.jpg": 2066,
	"./login/arbitrage-fund-passcode.jpg": 2067,
	"./login/badaIndex.gif": 2068,
	"./login/bse-1000-fund-passcode-banner.jpg": 2069,
	"./login/cancel_icon.png": 2070,
	"./login/check_icon.png": 2071,
	"./login/checked.png": 707,
	"./login/city_icon.png": 2072,
	"./login/digital-fund-passcode-hq.gif": 2073,
	"./login/email_icon.png": 2074,
	"./login/financial-fund-passcode-340x340.gif": 2075,
	"./login/gold_passcode.jpg": 2076,
	"./login/grow_more.png": 2077,
	"./login/grow_more_label_line.png": 2078,
	"./login/imc-gif.gif": 2079,
	"./login/infrastructure-fund-passcode.gif": 2080,
	"./login/kyc_verify_icon.png": 2081,
	"./login/microcapNFO.gif": 2082,
	"./login/mo-brand.gif": 2083,
	"./login/mobile_icon.png": 2084,
	"./login/multi-factor-passcode-340x340.gif": 2085,
	"./login/nfonew.jpg": 2086,
	"./login/nifty-capital-market.jpg": 2087,
	"./login/pan_icon.png": 2088,
	"./login/pan_name_icon.png": 2089,
	"./login/password_icon.png": 2090,
	"./login/pbanner.gif": 2091,
	"./login/pbanner_old.gif": 2092,
	"./login/show_password_icon.png": 2093,
	"./login/smallCap.gif": 2094,
	"./login/transcendGrowthImage1.jpg": 2095,
	"./loginpeople.svg": 2096,
	"./logo-dark-groww.83f43714.svg": 2097,
	"./logo-dit.png": 2098,
	"./logo-mfbrst.png": 2099,
	"./logo-mo-amc.png": 702,
	"./logo-mo-amc2.png": 703,
	"./logo.png": 2100,
	"./logo.svg": 2101,
	"./logout.png": 2102,
	"./lowcost-icon.jpg": 2103,
	"./lumpsum-icon.png": 2104,
	"./maa-diversify-banner.png": 2105,
	"./mailsms_icon.png": 2106,
	"./manageBank/edit_icon.svg": 2107,
	"./manageBank/edit_icon_black.svg": 2108,
	"./manageBank/icon_bank.svg": 2109,
	"./manageBank/nominee/close_icon.svg": 2110,
	"./manageBank/nominee/nomDeleteIcon.svg": 2111,
	"./manageBank/nominee/nomEditIcon.svg": 2112,
	"./manageBank/nominee/nomineeNoteIcon.svg": 2113,
	"./manageBank/nominee/nomineeSuccessIcon.svg": 2114,
	"./manageBank/nominee_icon.svg": 2115,
	"./manageBank/notestyle.png": 2116,
	"./manageBank/success.webp": 2117,
	"./mid-grows.png": 2118,
	"./midcap150-1st.png": 2119,
	"./midcap150-valuation-graph1.jpg": 2120,
	"./midcap150-valuation-graph2.jpg": 2121,
	"./minimalist-banner.png": 2122,
	"./minus.png": 2123,
	"./mo-icon.png": 2124,
	"./mosl-brst-logo.png": 2125,
	"./movipack/Capture.png": 2126,
	"./movipack/about_icon1.svg": 2127,
	"./movipack/about_icon1hover.svg": 2128,
	"./movipack/about_icon2.svg": 2129,
	"./movipack/about_icon2hover.svg": 2130,
	"./movipack/about_icon3.svg": 2131,
	"./movipack/about_icon3hover.svg": 2132,
	"./movipack/about_icon4.svg": 2133,
	"./movipack/about_icon4hover.svg": 2134,
	"./movipack/about_icon5.svg": 2135,
	"./movipack/about_icon5hover.svg": 2136,
	"./movipack/background1.png": 2137,
	"./movipack/background2.png": 2138,
	"./movipack/bannerbg.png": 2139,
	"./movipack/calender.svg": 2140,
	"./movipack/dividendyeiled.svg": 2141,
	"./movipack/graphp.svg": 2142,
	"./movipack/icon_rupee.svg": 2143,
	"./movipack/movi_banner_graph.png": 2144,
	"./movipack/moviepack_why.png": 2145,
	"./movipack/movipack_feature1.svg": 2146,
	"./movipack/movipack_feature1hover.svg": 2147,
	"./movipack/movipack_feature2.svg": 2148,
	"./movipack/movipack_feature2hover.svg": 2149,
	"./movipack/movipack_feature3.svg": 2150,
	"./movipack/movipack_feature3hover.svg": 2151,
	"./movipack/movipack_feature4.svg": 2152,
	"./movipack/movipack_feature4hover.svg": 2153,
	"./movipack/movipack_feature5.svg": 2154,
	"./movipack/movipack_feature5hover.svg": 2155,
	"./movipack/phylosophy.png": 2156,
	"./movipack/phylosophytwo.svg": 2157,
	"./movipack/riskometer_high.png": 2158,
	"./movipack/riskometer_low.png": 2159,
	"./movipack/xls.png": 2160,
	"./multi-asset-fund-weather-mobbanner.jpg": 2161,
	"./multi-asset-weather-desbanner.jpg": 2162,
	"./multiasset-balancing-mob.jpg": 2163,
	"./multiasset-balancing.jpg": 2164,
	"./multiasset-banner-invest.jpg": 2165,
	"./multiasset-banner-mob-invest.jpg": 2166,
	"./multiasset-banner-mob.jpg": 2167,
	"./multiasset-banner-single.jpg": 2168,
	"./multiasset-banner.jpg": 2169,
	"./n500-icon.png": 2170,
	"./nav/Group 253.svg": 2171,
	"./nav/aldemat_navicon-light.svg": 2172,
	"./nav/aldemat_navicon.svg": 2173,
	"./nav/cart.svg": 2174,
	"./nav/goalbase_navicon-light.svg": 2175,
	"./nav/goalbase_navicon.svg": 2176,
	"./nav/icon_LAS-hover.svg": 2177,
	"./nav/icon_LAS.svg": 2178,
	"./nav/invest_navicon-light.svg": 2179,
	"./nav/invest_navicon.svg": 2180,
	"./nav/logo-momf.png": 2181,
	"./nav/manageac_navicon-light.svg": 2182,
	"./nav/manageac_navicon.svg": 2183,
	"./nav/managepr_navicon-light.svg": 2184,
	"./nav/managepr_navicon.svg": 2185,
	"./nav/menu.png": 2186,
	"./nav/mf-amc-brst-logo.png": 2187,
	"./nav/mf-m-min-logo.svg": 2188,
	"./nav/mf-new-logo.png": 2189,
	"./nav/mnschedule_navicon-light.svg": 2190,
	"./nav/mnschedule_navicon.svg": 2191,
	"./nav/mo_logo.png": 2192,
	"./nav/moamc-mf-logo-new.png": 2193,
	"./nav/myportfolio_navicon-light.svg": 2194,
	"./nav/myportfolio_navicon.svg": 2195,
	"./nav/navBanner.svg": 2196,
	"./nav/navicon-othertransaction.svg": 2197,
	"./nav/navicon_siphouse_sip.svg": 2198,
	"./nav/orderbook_navicon-light.svg": 2199,
	"./nav/orderbook_navicon.svg": 2200,
	"./nav/otpPreference.svg": 2201,
	"./nav/profile-icon.png": 2202,
	"./nav/redemption_navicon-light.svg": 2203,
	"./nav/redemption_navicon.svg": 2204,
	"./nav/report_navicon-light.svg": 2205,
	"./nav/report_navicon.svg": 2206,
	"./nav/smartplan_navicon-light.svg": 2207,
	"./nav/smartplan_navicon.svg": 2208,
	"./nav/transfer_navicon-light.svg": 2209,
	"./nav/transfer_navicon.svg": 2210,
	"./nbank-icon.png": 2211,
	"./newuser.svg": 2212,
	"./nfo-closed-img.png": 2213,
	"./nfo-date-close.png": 2214,
	"./nfo-date-etf.png": 2215,
	"./nfo-date.png": 2216,
	"./nfo-n50-banner.png": 2217,
	"./nfo-navicon.svg": 2218,
	"./nfoBasket/ic_dot.png": 2219,
	"./nifty50-stocks-survived-graph.png": 2220,
	"./nifty50-survivorship-outperformance-graph.png": 2221,
	"./nifty50-whythisshift-graph.jpg": 2222,
	"./nifty50-whythisshift-graph2.jpg": 2223,
	"./nifty50-whythisshift-points.png": 2224,
	"./niftynext50-stocks-survived-graph.png": 2225,
	"./niftynext50-survivorship-outperformance-graph.png": 2226,
	"./nm150-icon.png": 2227,
	"./ns250-icon.png": 2228,
	"./onboarding/attachmentIcon.svg": 2229,
	"./onboarding/closeIcon.svg": 2230,
	"./onboarding/deleteIcon.svg": 2231,
	"./onboarding/female-icon.png": 2232,
	"./onboarding/male-icon.png": 2233,
	"./onboarding/nomineeFamilyIcon.svg": 2234,
	"./onboarding/transgender-icon.png": 2235,
	"./onboarding/uploadIcon.svg": 2236,
	"./option_icon.png": 2237,
	"./passive-fund-info.jpg": 2238,
	"./payment/info-icon.svg": 2239,
	"./payment/mastercard-icon.svg": 2240,
	"./payment/neft-rtgs-icon.svg": 2241,
	"./payment/net-banking-icon.svg": 2242,
	"./payment/payment-method-icon.svg": 2243,
	"./payment/upi-icon.svg": 2244,
	"./perfor-tab-icon.png": 2245,
	"./performanceglobalindices-graph.png": 2246,
	"./performancestrategy-fofac.png": 2247,
	"./plusicon.png": 2248,
	"./pms/BusinessPortfolio.png": 2249,
	"./pms/DedicatedRMs.png": 2250,
	"./pms/EqualityPortfolioGirl.svg": 2251,
	"./pms/IndiaOpportunityV1.png": 2252,
	"./pms/IndiaOpportunityV2.png": 2253,
	"./pms/Linkedinlogo.png": 2254,
	"./pms/Next-trillion.png": 2255,
	"./pms/PMS-Tree.svg": 2256,
	"./pms/PerformanceChart.png": 2257,
	"./pms/RaamdeoAggarwal.png": 2258,
	"./pms/RequestDeskGirl.svg": 2259,
	"./pms/RightWave.png": 2260,
	"./pms/Segregatedportfolios.png": 2261,
	"./pms/Telephone.png": 2262,
	"./pms/Transparency.png": 2263,
	"./pms/ValueStrategy.png": 2264,
	"./pms/pdf_download_icon.png": 704,
	"./portfo-tab-icon.png": 2265,
	"./postlogin/12_PMS_Reports_Fees Payable.jpg": 2266,
	"./postlogin/Group 26759.svg": 2267,
	"./postlogin/Path 20089.jpg": 2268,
	"./postlogin/addedcart-icon.svg": 2269,
	"./postlogin/addtocart-icon.svg": 2270,
	"./postlogin/authentication-icon.svg": 2271,
	"./postlogin/average-icon.svg": 2272,
	"./postlogin/bank-icon.svg": 2273,
	"./postlogin/bitcoin.svg": 2274,
	"./postlogin/boost-btn-icon.png": 2275,
	"./postlogin/broker-error-icon.svg": 2276,
	"./postlogin/broker-icon.svg": 2277,
	"./postlogin/call-icon.svg": 2278,
	"./postlogin/cancel (2).svg": 2279,
	"./postlogin/cant-say-icon.svg": 2280,
	"./postlogin/card-add-to-cart-icon.svg": 2281,
	"./postlogin/card-lumpsum-icon.svg": 2282,
	"./postlogin/card-sip-icon.svg": 2283,
	"./postlogin/cart-icon.svg": 2284,
	"./postlogin/cart-review-edit.jpg": 2285,
	"./postlogin/carttable-infoicon.svg": 2286,
	"./postlogin/cashflow-checkout-icon.svg": 2287,
	"./postlogin/cd-icon-arrow-next.svg": 2288,
	"./postlogin/cd-icon-select.svg": 2289,
	"./postlogin/cd-icons-cart-close.svg": 2290,
	"./postlogin/cheque-icon.svg": 2291,
	"./postlogin/delete-icon.svg": 2292,
	"./postlogin/direct-ribbon.svg": 2293,
	"./postlogin/edit-icon.svg": 2294,
	"./postlogin/elss-fund.gif": 2295,
	"./postlogin/email-icon.svg": 2296,
	"./postlogin/error-table-icon.svg": 2297,
	"./postlogin/existinguser.svg": 2298,
	"./postlogin/exit-load-icon.svg": 2299,
	"./postlogin/facebook-logo.svg": 2300,
	"./postlogin/filter-icon.svg": 2301,
	"./postlogin/folio-icon.svg": 2302,
	"./postlogin/folio-joint.svg": 2303,
	"./postlogin/folio-minor.svg": 2304,
	"./postlogin/folio-single.svg": 2305,
	"./postlogin/footer-blue-bg.svg": 2306,
	"./postlogin/footer-chatwithus-icon.svg": 2307,
	"./postlogin/footer-faqs-icon.svg": 2308,
	"./postlogin/footer-searchlocation-icon.svg": 2309,
	"./postlogin/footer-whatsapp-icon.svg": 2310,
	"./postlogin/good-icon.svg": 2311,
	"./postlogin/greenarrow-icon.svg": 2312,
	"./postlogin/greentick-icon.svg": 2313,
	"./postlogin/grid-icon.svg": 2314,
	"./postlogin/index-funds.gif": 2315,
	"./postlogin/info-icon.svg": 2316,
	"./postlogin/infobig-icon.svg": 2317,
	"./postlogin/instagram-logo.svg": 2318,
	"./postlogin/internationalBG.jpg": 2319,
	"./postlogin/list-icon.svg": 2320,
	"./postlogin/loader-logo.svg": 2321,
	"./postlogin/main-clip.svg": 2322,
	"./postlogin/mandate-homepage-banner.jpg": 2323,
	"./postlogin/mandate-icon.svg": 2324,
	"./postlogin/mastercard-icon.svg": 2325,
	"./postlogin/money-bag.svg": 2326,
	"./postlogin/more-vertical.svg": 2327,
	"./postlogin/multiasset-balancing-mob-banner.jpg": 2328,
	"./postlogin/neft-rtgs-icon.svg": 2329,
	"./postlogin/neftrtgs-icon.svg": 2330,
	"./postlogin/net-banking-icon.svg": 2331,
	"./postlogin/netbanking-otm-icon.svg": 2332,
	"./postlogin/newuser.svg": 2333,
	"./postlogin/order-icon.svg": 2334,
	"./postlogin/otm-mandate-mob.jpg": 2335,
	"./postlogin/payment-fail.svg": 2336,
	"./postlogin/payment-method-icon.svg": 2337,
	"./postlogin/payment-success.svg": 2338,
	"./postlogin/payment-summary-icon.svg": 2339,
	"./postlogin/payment-waiting.svg": 2340,
	"./postlogin/pms-homepage-mob-banner.jpg": 2341,
	"./postlogin/poor-icon.svg": 2342,
	"./postlogin/portfolio-details-section.svg": 2343,
	"./postlogin/product-preview.png": 2344,
	"./postlogin/profit.svg": 2345,
	"./postlogin/redamount-icon.svg": 2346,
	"./postlogin/redarrow-icon.svg": 2347,
	"./postlogin/redemption-icon.svg": 2348,
	"./postlogin/regular-ribbon.svg": 2349,
	"./postlogin/review-checkout-icon.svg": 2350,
	"./postlogin/rupee-sign.svg": 2351,
	"./postlogin/schedule-sip-icon.svg": 2352,
	"./postlogin/search-icon.svg": 2353,
	"./postlogin/sip-error-icon.svg": 2354,
	"./postlogin/sip-shubh-aarambh-mob-banner.jpg": 2355,
	"./postlogin/sipmenu-bank.svg": 2356,
	"./postlogin/sipmenu-cancel.svg": 2357,
	"./postlogin/sipmenu-feedback.svg": 2358,
	"./postlogin/sipmenu-pause.svg": 2359,
	"./postlogin/sipmenu-statement.svg": 2360,
	"./postlogin/small-clip.svg": 2361,
	"./postlogin/stp-icon.svg": 2362,
	"./postlogin/swp-icon.svg": 2363,
	"./postlogin/tax-icon.svg": 2364,
	"./postlogin/thank-you.png": 2365,
	"./postlogin/topblock-section.svg": 2366,
	"./postlogin/twitter-logo.svg": 2367,
	"./postlogin/upi-icon.svg": 2368,
	"./postlogin/ver-poor-icon.svg": 2369,
	"./postlogin/very-good-icon.svg": 2370,
	"./postlogin/whatsapp-banner.jpg": 2371,
	"./postlogin/x-circle.svg": 2372,
	"./postlogin/youtube-logo.svg": 2373,
	"./prelogin-header/Logo.png": 2374,
	"./prelogin-header/basket-banner.gif": 2375,
	"./prelogin-header/cashflow-img.svg": 2376,
	"./prelogin-header/login-icon.svg": 2377,
	"./prelogin-header/login-lock.svg": 2378,
	"./prelogin-header/logo-mo-asset.png": 2379,
	"./prelogin-header/loudspeaker.png": 2380,
	"./prelogin-header/movi-img.svg": 2381,
	"./prelogin-header/nfo_beacon.gif": 2382,
	"./prelogin-header/quick-invest-icon.svg": 2383,
	"./presentation-icon.svg": 2384,
	"./produc-tab-icon.png": 2385,
	"./profile/ach_icon.png": 2386,
	"./profile/addprofile.svg": 2387,
	"./profile/bill_icon.png": 2388,
	"./profile/contact_icon.png": 2389,
	"./profile/editIcon.svg": 2390,
	"./profile/fatca2_icon.png": 2391,
	"./profile/folio-icon.svg": 2392,
	"./profile/mail_icon.png": 2393,
	"./profile/mailsms_icon.png": 2394,
	"./profile/mandate_icon.png": 2395,
	"./profile/minus.png": 2396,
	"./profile/netbankg_icon.png": 2397,
	"./profile/nominee_icon.png": 2398,
	"./profile/plus.png": 2399,
	"./profile/profile_pic.png": 2400,
	"./profile/sms_icon.png": 2401,
	"./profile/thankyou_icon.png": 2402,
	"./profile/user_icon.png": 2403,
	"./reblancing-icon.jpg": 2404,
	"./reedem.svg": 2405,
	"./rightarrow.svg": 2406,
	"./rightbg.svg": 2407,
	"./risk-fofac-h.png": 2408,
	"./risk-fofac-vh.png": 2409,
	"./riskometer-h.png": 2410,
	"./riskometer-low.png": 2411,
	"./riskometer-m-gsec-fof.png": 2412,
	"./riskometer-mh-etf.png": 2413,
	"./riskometer-mh.png": 2414,
	"./riskometer-moderate.png": 2415,
	"./riskometer-moderately-high.png": 2416,
	"./riskometer-moderately-low.png": 2417,
	"./riskometer-very-high.png": 2418,
	"./riskometerH.png": 2419,
	"./riskreduction-icon.jpg": 2420,
	"./searchicon.png": 2421,
	"./services-bg-rev.png": 2422,
	"./services-bg.png": 2423,
	"./share-icon.png": 2424,
	"./sid-icon.svg": 2425,
	"./sip-icon.png": 2426,
	"./sip.svg": 2427,
	"./sipHouse/boosterImages/downEllipse.png": 2428,
	"./sipHouse/boosterImages/upEllipse.png": 2429,
	"./sipHouse/down_arrow.svg": 2430,
	"./sipHouse/enter_sip_amt_bg_desktop.png": 2431,
	"./sipHouse/failureCheckmark.png": 2432,
	"./sipHouse/failureDesktop_bg.png": 2433,
	"./sipHouse/failureMobile_bg.jpg": 2434,
	"./sipHouse/ic_info.png": 2435,
	"./sipHouse/lowerEcllipse.png": 2436,
	"./sipHouse/short-arrow.svg": 2437,
	"./sipHouse/successCheckmark.png": 2438,
	"./sipHouse/successDesktop_bg.png": 2439,
	"./sipHouse/successMobile_bg.png": 2440,
	"./sipHouse/thankyouBannerNewDesktop.png": 2441,
	"./sipHouse/thankyouBannerNewMobile.png": 2442,
	"./sipHouse/up_arrow.svg": 2443,
	"./sipHouse/upperEcllipse.png": 2444,
	"./sipbooster/banner_bline.svg": 2445,
	"./sipbooster/banner_graphic.png": 2446,
	"./sipbooster/banner_graphic.svg": 2447,
	"./sipbooster/banner_tringleimg.svg": 2448,
	"./sipbooster/benefits_automatesavingicon.svg": 2449,
	"./sipbooster/benefits_fastrackicon.svg": 2450,
	"./sipbooster/benefits_shadow.svg": 2451,
	"./sipbooster/benefits_simpleinv.svg": 2452,
	"./sipbooster/benefits_sipbooster_creatoricon.svg": 2453,
	"./sipbooster/benefits_sipbooster_investmenticon.svg": 2454,
	"./sipbooster/breakline.svg": 2455,
	"./sipbooster/calendericon.svg": 2456,
	"./sipbooster/coin_booster.svg": 2457,
	"./sipbooster/coin_icon.svg": 2458,
	"./sipbooster/dashed line.svg": 2459,
	"./sipbooster/faq_graphic.svg": 2460,
	"./sipbooster/growthinvestment_bar1.svg": 2461,
	"./sipbooster/growthinvestment_bar2.svg": 2462,
	"./sipbooster/growthinvestment_bar3.svg": 2463,
	"./sipbooster/growthinvestment_bar4.svg": 2464,
	"./sipbooster/icon_rupee.svg": 2465,
	"./sipbooster/infographic_MSA.svg": 2466,
	"./sipbooster/infographic_MSB.svg": 2467,
	"./sipbooster/invest-now.png": 2468,
	"./sipbooster/leftarrow.svg": 2469,
	"./sipbooster/rightarrow.svg": 2470,
	"./sipbooster/topbannerboarder.svg": 2471,
	"./sipperformace-icon.png": 2472,
	"./skin-in-the-game-banner-mob.jpg": 2473,
	"./skin-in-the-game-banner.jpg": 2474,
	"./slide1.png": 741,
	"./small-calendar-2.svg": 2475,
	"./small-calendar.svg": 2476,
	"./small-riskometer-h.png": 2477,
	"./small-riskometer-l.png": 2478,
	"./small-riskometer-mh.png": 2479,
	"./smallcap250-valuation-graph1.jpg": 2480,
	"./spindex-banner-inner-mob.jpg": 2481,
	"./spindex-banner-inner.jpg": 2482,
	"./spindex-banner-mob.jpg": 2483,
	"./spindex-banner.gif": 2484,
	"./spindex-banner.jpg": 2485,
	"./stability-growth.png": 2486,
	"./stp.svg": 2487,
	"./sub-img.png": 2488,
	"./sweet-spot-1-etf.png": 2489,
	"./sweet-spot-1-gsec-fof.png": 2490,
	"./sweet-spot-2-etf.png": 2491,
	"./sweet-spot-2-gsec-fof.png": 2492,
	"./swipe-icon.png": 2493,
	"./switch.svg": 2494,
	"./swp.svg": 2495,
	"./tab-icon-1y.png": 2496,
	"./tab-icon-2y.png": 2497,
	"./tab-icon-3y.png": 2498,
	"./tab-icon-4y.png": 2499,
	"./tab-icon-why1y.png": 2500,
	"./tax-returns-etf.png": 2501,
	"./tax-returns-gec-fof.png": 2502,
	"./taxef-icon.jpg": 2503,
	"./thank-you.png": 2504,
	"./the-right-mix-img.png": 2505,
	"./think-MO-line-1.png": 2506,
	"./thumbs-up.png": 2507,
	"./tnc/Plus.png": 2508,
	"./tnc/disclaimer.jpg": 2509,
	"./tnc/minus.png": 2510,
	"./tnc/terms.jpg": 2511,
	"./tnc/yellowcolor.png": 2512,
	"./tools/Car-Big.png": 2513,
	"./tools/Car-inner.png": 2514,
	"./tools/Education-Big.png": 2515,
	"./tools/Education-inner.png": 2516,
	"./tools/Holiday-Big.png": 2517,
	"./tools/Holiday-inner.png": 2518,
	"./tools/House-Big.png": 2519,
	"./tools/House-Inner.png": 2520,
	"./tools/Money Plant.png": 2521,
	"./tools/Wedding-Big.png": 2522,
	"./tools/Wedding-inner.png": 2523,
	"./tools/compare-portfolio-default.png": 2524,
	"./tools/compare-portfolio.png": 2525,
	"./tools/compounding-magic-default.png": 2526,
	"./tools/compounding-magic.png": 2527,
	"./tools/goal-calculator-default.png": 2528,
	"./tools/goal-calculator.png": 2529,
	"./tools/sip-calculator-default.png": 2530,
	"./tools/sip-calculator.png": 2531,
	"./topup-icon.png": 2532,
	"./trackorder/bannersection.jpg": 2533,
	"./trackorder/calender.svg": 2534,
	"./trackorder/filter-icon.svg": 2535,
	"./trackorder/graphics-noinfofound.png": 2536,
	"./trackorder/icon-unclaimred.png": 2537,
	"./trackorder/order-icon.svg": 2538,
	"./trackorder/order_book_dfn.svg": 2539,
	"./trackorder/small-clip.svg": 2540,
	"./trans/Group 8999.png": 2541,
	"./trans/Group 9000.png": 2542,
	"./trans/Rectangle 4355.png": 2543,
	"./trans/Rectangle 4356.png": 2544,
	"./trans/Vector Smart Object.svg": 2545,
	"./trans/addmoney.png": 2546,
	"./trans/authentication-icon.svg": 2547,
	"./trans/bank-icon.svg": 2548,
	"./trans/boost-icon.png": 2549,
	"./trans/broker-icon.svg": 2550,
	"./trans/cart-icon.svg": 2551,
	"./trans/cashflow_icon.svg": 2552,
	"./trans/dematFolioPopupIcon.svg": 2553,
	"./trans/exit-load-icon.svg": 2554,
	"./trans/folio-icon.svg": 2555,
	"./trans/greenarrow-icon.svg": 2556,
	"./trans/info-icon.svg": 2557,
	"./trans/infobig-icon.svg": 2558,
	"./trans/invest-fund-icon.svg": 2559,
	"./trans/isip-icon.svg": 2560,
	"./trans/isip.png": 2561,
	"./trans/main-clip.svg": 2562,
	"./trans/minus-icon.svg": 2563,
	"./trans/new-fund-icon.svg": 2564,
	"./trans/new-fund-side-img.svg": 2565,
	"./trans/pigybank.png": 2566,
	"./trans/plus-icon.svg": 2567,
	"./trans/redamount-icon.svg": 2568,
	"./trans/redarrow-icon.svg": 2569,
	"./trans/redemption-graph.png": 2570,
	"./trans/redemption-icon.svg": 2571,
	"./trans/redemtionthank.png": 2572,
	"./trans/sip-img.svg": 2573,
	"./trans/small-clip.svg": 2574,
	"./trans/stp-icon.svg": 2575,
	"./trans/stpdetailsicon.svg": 2576,
	"./trans/swp-icon.svg": 2577,
	"./trans/swp-img.svg": 2578,
	"./trans/tax-icon.svg": 2579,
	"./transResponse/elss-fund.gif": 2580,
	"./transResponse/index-funds.gif": 2581,
	"./transResponse/mandate-homepage-banner.jpg": 2582,
	"./transResponse/order-icon.svg": 2583,
	"./transResponse/otm-mandate-mob.jpg": 2584,
	"./transResponse/payment-success.svg": 2585,
	"./transResponse/pending-consent-icon.png": 2586,
	"./transResponse/pending-consent-icon.svg": 2587,
	"./transResponse/smallbanners_Motial-Oswal-Large-and-Midcap-Fund.jpg": 2588,
	"./transResponse/smallbanners_Motilal-Oswal-Flexicap-Fund.jpg": 2589,
	"./transResponse/smallbanners_Motilal-Oswal-Midcap-Fund.jpg": 2590,
	"./transResponse/whatsapp-banner old.jpg": 2591,
	"./transResponse/whatsapp-banner.jpg": 2592,
	"./tri.png": 2593,
	"./us-market-cloud.png": 2594,
	"./user.png": 742,
	"./video-1.jpg": 2595,
	"./video-2.jpg": 2596,
	"./video-3.jpg": 2597,
	"./whatsapp-icon.gif": 2598,
	"./whatsapp_banner_headline_desktop.gif": 2599,
	"./whatsapp_banner_headline_mobile.gif": 2600,
	"./why-fund-icon.png": 2601,
	"./why-index-sec-left.png": 2602,
	"./wl-1.png": 2603,
	"./wl-1w.png": 2604,
	"./wl-2.png": 2605,
	"./wl-2w.png": 2606,
	"./wl-3.png": 2607,
	"./wl-3w.png": 2608,
	"./wl-4.png": 2609,
	"./wl-4w.png": 2610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;